// extracted by mini-css-extract-plugin
export var wrapper = "transactions-module--wrapper--zOWxI";
export var __jsonKey__ = "transactions-module--__json-key__--Typ3R";
export var errorColor = "transactions-module--errorColor--3SDH1";
export var loader = "transactions-module--loader--OmW6y";
export var spin = "transactions-module--spin--Z+iYO";
export var title = "transactions-module--title--DQ342";
export var cardTitle = "transactions-module--card-title--MrnXz";
export var boxWrapper = "transactions-module--box-wrapper--5wfyV";
export var box = "transactions-module--box--bDTQF";